require('backbone.stickit');
require('backbone-validation');
var DateUtils = require('../utils/dates');
var StringUtils = require('../utils/strings');
var commonInterfaceMixin = {
    validatedFields: [],
    // A list of the fields that have received focus
    _visitedFields: [],
    validateVisitedFieldsOnly: true,
    _addVisitedField: function (fieldName) {
        if (!fieldName) {
            return;
        }
        if (this._visitedFields.indexOf(fieldName) === -1) {
            this._visitedFields.push(fieldName);
        }
    },
    _setElementAsVisited: function ($visitedElement) {
        this._addVisitedField($visitedElement.attr('name'));
        $visitedElement.attr('focused', true);
    },
    _isVisitedField: function (fieldName) {
        return this._visitedFields.indexOf(fieldName) !== -1;
    },
    toggleElementValidationError: function ($el, on, error) {
        var $group = $el.closest('.form-group');
        if (on) {
            $group.addClass('has-error');
            if (error) {
              $group.find('.help-block').html(error).removeClass('hidden');
            }
            $group.find('.form-control-feedback').removeClass('hidden');
        } else {
            $group.removeClass('has-error');
            $group.find('.help-block').html('').addClass('hidden');
            $group.find('.form-control-feedback').addClass('hidden');
        }
    },
    modelEvents: {
        'before:validation': function () {
            var self = this;
            var validatedFields = _.result(this, 'validatedFields');
            _.each(validatedFields, function (element, index, list) {
                self._addVisitedField(element);
            });
        }
    },
    onModelAttributeValid: function (attr, selector) {
        if (!this.isRendered) {
            return false;
        }
        this.toggleElementValidationError(this.$('[name=' + attr + ']'), false);
        return true;
    },
    onModelAttributeInvalid: function (attr, error, selector) {
        if (!this.isRendered) {
            return false;
        }
        var $el = this.$('[name=' + attr + ']');
        if (!this.validateVisitedFieldsOnly || (this.validateVisitedFieldsOnly && this._isVisitedField($el.attr('name')))) {
            // Only inputs that have received focus should show the error.
            this.toggleElementValidationError($el, true, error);
        }
        return true;
    },
    onRender: function () {
        if (this.model || this.collection) {
            Backbone.Validation.bind(this);
        }
        if (this.bindings) {
            this.stickit();
        }
    },
    onDestroy: function () {
        if (this.model || this.collection) {
            Backbone.Validation.unbind(this);
        }
        if (this.bindings) {
            this.unstickit();
        }
    },
    _bindModelAttrToDomAttribute: function (model, modelAttr, domAttr, valueCallback) {
        var self = this;

        function getAttrValue (model) {
            if (valueCallback) {
                return valueCallback.call(self, model.get(modelAttr));
            } else {
                return model.get(modelAttr) || '';
            }
        }

        self.$el.attr(
            domAttr,
            getAttrValue(model)
        );
        model.on('change:' + modelAttr, function (model, value, options) {
             self.$el.attr(domAttr, getAttrValue(model));
        });
    },
    templateHelpers: function () {
        return {
            viewId: this.viewId(),
            DateUtils: DateUtils,
            StringUtils: StringUtils
        };
    },
    viewId: function () {
        return this.cid;
    }
};

_.extend(Backbone.Validation.callbacks, {
    valid: function (view, attr, selector) {
        var validatedFields = _.result(view, 'validatedFields');
        if (validatedFields && validatedFields.indexOf(attr) === -1) {
            return;
        }
        view.onModelAttributeValid(attr, selector);
    },
    invalid: function (view, attr, error, selector) {
        var validatedFields = _.result(view, 'validatedFields');
        if (validatedFields && validatedFields.indexOf(attr) === -1) {
            return;
        }
        view.onModelAttributeInvalid(attr, error, selector);
    }
});

var ItemView = Marionette.ItemView.extend({});
_.extend(ItemView.prototype, commonInterfaceMixin);

var LayoutView = Marionette.LayoutView.extend({});
_.extend(LayoutView.prototype, commonInterfaceMixin);

var CollectionView = Marionette.CollectionView.extend({});

module.exports = {
    CollectionView: CollectionView,
    LayoutView: LayoutView,
    ItemView: ItemView
};



/** WEBPACK FOOTER **
 ** ./assets/js/common/base.js
 **/